import React from 'react';
import PropTypes from 'prop-types';
import useBrand from '../../../hooks/use-brand';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './SplashCta.less';
import useDevice from '../../../hooks/use-device';
import MobileSplashCta from './fields/MobileSplashCta';
import DesktopSplashCta from './fields/DesktopSplashCta';
export var SplashCta = function SplashCta(_ref) {
  var data = _ref.data,
      content = _ref.content;
  var brand = useBrand();
  var device = useDevice();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var splashCTAButtons = _ref2$component$conte.embedded_splash_cta;
  return splashCTAButtons && splashCTAButtons.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: ['splash-cta-button-wrapper'],
      device: device
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: ['splashCtaButtons'],
      brand: brand,
      device: device
    })
  }, device.isMobile() ? /*#__PURE__*/React.createElement(MobileSplashCta, {
    content: content,
    splashCTAButtons: splashCTAButtons
  }) : /*#__PURE__*/React.createElement(DesktopSplashCta, {
    splashCTAButtons: splashCTAButtons
  }))) : null;
};
SplashCta.propTypes = {
  data: PropTypes.object.isRequired
};
export default SplashCta;